module.exports = __webpack_public_path__ + "middle-img-bg.png?8e4e09a321b64e2eb97d8a5307d90356";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ProductAndService/MOBEC/middle-img-bg.png
// module id = 171
// module chunks = 0